export const BREAKPOINT_LAPTOP = 1366;
export const BREAKPOINT_M = 1280;
export const DESKTOP_SIZE = 768;
export const BREAKPOINT_XS = 600;
